import type { GameState } from '../../engine/game-state.js';
import { createLayout, rowAbove } from '../../render/three/layout.js';
import type { GameSpec } from '../../render/three/game-app.js';
import { drawFromStock, golfRules, hasAnyMatch, TABLEAU_IDS } from './rules.js';

const TABLEAU_Z = 0.0;
const TOP_Z = rowAbove(TABLEAU_Z);

// Stock and foundation flank the centre column on the top row.
const layout = createLayout({
  cols: 7,
  rows: [
    { z: TOP_Z, slots: [null, null, 'stock', null, 'foundation', null, null] },
    { z: TABLEAU_Z, fanDown: true, slots: [...TABLEAU_IDS] },
  ],
});

function playToFoundation(state: GameState, fromId: string, cardId: string): boolean {
  const move = { from: fromId, to: 'foundation', cardId };
  if (!golfRules.canMove(state, move)) return false;
  const fromPile = state.piles[fromId]!;
  const card = fromPile.cards.pop()!;
  state.piles.foundation!.cards.push(card);
  state.movesCount++;
  return true;
}

export const golfSpec: GameSpec = {
  rules: golfRules,
  slotForPile: (id) => layout.slot(id),
  // No drag in Golf - every move is a click (tableau top or stock → foundation).
  dropExclude: () => [...TABLEAU_IDS, 'stock', 'foundation'],
  dragStackIds: () => [],
  autoSendOrder: () => ['foundation'],
  // Columns only ever shrink from the 5-card deal, so the fan never exceeds 5.
  maxFanLength: 5,
  onPileClick(state, pile, cardId) {
    if (pile.id === 'stock') {
      if (!drawFromStock(state)) return false;
      state.movesCount++;
      return true;
    }
    if (pile.type === 'tableau') {
      return playToFoundation(state, pile.id, cardId);
    }
    return false;
  },
  statusText(state) {
    const stockEmpty = state.piles.stock!.cards.length === 0;
    if (stockEmpty && !hasAnyMatch(state) && !golfRules.isWon(state)) return 'No moves left';
    return null;
  },
  cascadeCardIds(state) {
    return state.piles.foundation!.cards.map((c) => c.id);
  },
  // Tableau columns aren't refilled (empty == cleared), so only anchor the two
  // persistent piles.
  showSlotMarker: (id) => id === 'stock' || id === 'foundation',
};
